import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.split";
import _slicedToArray from "/app/node_modules/@babel/runtime-corejs2/helpers/slicedToArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { deepClone } from '@/modules/mm-utils';
import { API_REQUEST } from '@/api/';
import moment from 'moment';
import workerDaysByArg from "./common/workerDaysByArg";
import dayjs from 'dayjs';
import { numberToTimeString } from '@/common/helpers';

function formWorkerDayData(_ref) {
  var shifts = _ref.shifts,
      currentDepId = _ref.currentDepId,
      date = _ref.date,
      emplId = _ref.emplId,
      isFact = _ref.isFact,
      specialDayTypeCodes = _ref.specialDayTypeCodes;
  shifts.forEach(function (wDay) {
    if (!specialDayTypeCodes.includes(wDay.type)) {
      delete wDay['worker_day_details'];
    } else if (!wDay.isAnotherDep && wDay['work_type_id']) {
      wDay['worker_day_details'] = [{
        'work_type_id': wDay['work_type_id'],
        'work_part': 1
      }];
    }

    if (!wDay['shop_id']) {
      wDay['shop_id'] = currentDepId;
    }

    var beginDate = wDay['dttm_work_start'];
    var endDate = wDay['dttm_work_end'];

    if (beginDate && endDate) {
      var isInvalid = moment(beginDate).isAfter(endDate);

      if (isInvalid) {
        endDate = moment(endDate).add(1, 'day').format('YYYY-MM-DDTHH:mm:ss');
        wDay['dttm_work_end'] = endDate;
      }
    }

    if (!beginDate) {
      delete wDay['dttm_work_start'];
    }

    if (!endDate) {
      delete wDay['dttm_work_end'];
    } // properties should be removed


    var items = ['work_type_id', 'parent_worker_day_id', // 'work_hours',
    'isAnotherDep', 'employment_id'];
    items.forEach(function (key) {
      return delete wDay[key];
    });
    wDay['dt'] = date;
    wDay['employee_id'] = emplId;
    wDay['is_fact'] = isFact; // сделать в зависимости от ALLOWED_WORKER_HOUR_METHODS ?

    if (wDay.work_hours && !(typeof wDay.work_hours === 'string' || wDay.work_hours instanceof String)) {
      wDay.work_hours = numberToTimeString(wDay.work_hours, true);
    }
  });
}

function formNonWorkDayChangeDay(_ref2) {
  var shifts = _ref2.shifts,
      currentDepId = _ref2.currentDepId,
      cellId = _ref2.cellId;
  var changedDay = shifts.reduce(function (acc, day) {
    var dayDetails = day.worker_day_details;

    if (dayDetails !== null && dayDetails !== void 0 && dayDetails.length) {
      day.work_type_id = dayDetails[0].work_type_id;
    }

    day.isAnotherDep = day.type === 'W' && day.shop_id !== +currentDepId;

    if (!day.isAnotherDep) {
      day.shop_id = +currentDepId;
    }

    if (!acc.id) {
      acc = _objectSpread(_objectSpread({}, day), {}, {
        shifts: [day],
        shiftCount: 1
      });
    } else {
      acc.shifts.push(day);
      acc.shiftCount++;
    }

    var itemArg = day.is_fact ? 'FACT_UNAPPR' : 'PLAN_UNAPPR';

    if (!workerDaysByArg.hasValues(itemArg)) {
      workerDaysByArg.add(itemArg, cellId, day);
    }

    return acc;
  }, {});
  return changedDay;
}

function formWorkDayChangeDay(_ref3) {
  var shifts = _ref3.shifts,
      currentDepId = _ref3.currentDepId,
      cellId = _ref3.cellId,
      workDay = _ref3.workDay;
  var changedDay = shifts.reduce(function (acc, day) {
    var dayDetails = day.worker_day_details;

    if (dayDetails !== null && dayDetails !== void 0 && dayDetails.length) {
      day.work_type_id = dayDetails[0].work_type_id;
    }

    acc.isAnotherDep = acc.isAnotherDep || day.type === 'W' && day.shop_id !== +currentDepId;
    day.isAnotherDep = day.type === 'W' && day.shop_id !== +currentDepId;

    if (!day.isAnotherDep) {
      day.shop_id = +currentDepId;
    }

    if (!acc.id) {
      acc = _objectSpread(_objectSpread({}, day), {}, {
        shifts: [day],
        shiftCount: 1
      });
    } else {
      if (!acc.shifts) {
        acc.shifts = [];
        acc.shiftCount = 0;
      }

      acc.shifts.push(day);
      acc.shiftCount++;
    }

    var itemArg = day.is_fact ? 'FACT_UNAPPR' : 'PLAN_UNAPPR';

    if (!workerDaysByArg.hasValues(itemArg)) {
      workerDaysByArg.add(itemArg, cellId, day);
    }

    return acc;
  }, _objectSpread({}, workDay));
  return changedDay;
}

function updateStats(_x) {
  return _updateStats.apply(this, arguments);
}

function _updateStats() {
  _updateStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
    var _result$data;

    var result, currentDepId, cellId, commit, dispatch, changedDay, workDay;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = _ref4.result, currentDepId = _ref4.currentDepId, cellId = _ref4.cellId, commit = _ref4.commit, dispatch = _ref4.dispatch;
            changedDay = null;

            if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && _result$data.length) {
              workDay = result.data.find(function (el) {
                return el.type === 'W';
              });

              if (!workDay) {
                changedDay = formNonWorkDayChangeDay({
                  shifts: result.data,
                  currentDepId: currentDepId,
                  cellId: cellId
                });
              } else {
                changedDay = formWorkDayChangeDay({
                  shifts: result.data,
                  currentDepId: currentDepId,
                  cellId: cellId,
                  workDay: workDay
                });
              }
            }

            if (changedDay) {
              changedDay.shifts.sort(function (a, b) {
                return dayjs(a.dttm_work_start) - dayjs(b.dttm_work_start);
              });
            }

            commit('changeDay', {
              cellId: cellId,
              changedDay: changedDay
            });
            _context2.next = 7;
            return dispatch('updateWorkerStats', {
              forceUpdate: true
            });

          case 7:
            dispatch('applyTableView', {});

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _updateStats.apply(this, arguments);
}

export default /*#__PURE__*/(function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref5, cellId) {
    var _workerDay$data$, _workerDay$data$2, _state$removedShifts$, _wdUpdate, _wdUpdate2;

    var state, rootGetters, dispatch, commit, getters, _cellId$split, _cellId$split2, date, emplId, workerDay, isFact, currentDepId, specialDayTypeCodes, cellId_, wdDelete, wdPost, wdUpdate, _iterator, _step, wd, _iterator2, _step2, _wd, _iterator3, _step3, _wd2, _yield$API_REQUEST, _yield$API_REQUEST2, error, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            state = _ref5.state, rootGetters = _ref5.rootGetters, dispatch = _ref5.dispatch, commit = _ref5.commit, getters = _ref5.getters;
            _cellId$split = cellId.split('_'), _cellId$split2 = _slicedToArray(_cellId$split, 2), date = _cellId$split2[0], emplId = _cellId$split2[1];
            workerDay = {
              data: deepClone(state.dayInEditing[0].shifts)
            };
            isFact = state.tableCellParts[0].substr(0, 4) === 'FACT';
            currentDepId = rootGetters['queryMirrored/getOneDep'];
            specialDayTypeCodes = getters.specialDayTypeCodes;
            formWorkerDayData({
              shifts: workerDay.data,
              currentDepId: currentDepId,
              date: date,
              emplId: emplId,
              isFact: isFact,
              specialDayTypeCodes: specialDayTypeCodes
            });
            workerDay['options'] = {
              'return_response': true,
              'delete_scope_values_list': [{
                'employee_id': emplId,
                'dt': date,
                'is_fact': isFact,
                'is_approved': false
              }]
            };
            cellId_ = ((_workerDay$data$ = workerDay.data[0]) === null || _workerDay$data$ === void 0 ? void 0 : _workerDay$data$.dt) + '_' + ((_workerDay$data$2 = workerDay.data[0]) === null || _workerDay$data$2 === void 0 ? void 0 : _workerDay$data$2.employee_id);
            wdDelete = (_state$removedShifts$ = state.removedShifts[cellId]) === null || _state$removedShifts$ === void 0 ? void 0 : _state$removedShifts$.filter(function (el) {
              var _state$newShifts$cell;

              return !((_state$newShifts$cell = state.newShifts[cellId_]) !== null && _state$newShifts$cell !== void 0 && _state$newShifts$cell.includes(el));
            });
            wdPost = deepClone(workerDay).data.filter(function (el) {
              var _state$newShifts$cell2;

              return (_state$newShifts$cell2 = state.newShifts[cellId_]) === null || _state$newShifts$cell2 === void 0 ? void 0 : _state$newShifts$cell2.includes(el.newId);
            }).filter(function (el) {
              var _state$removedShifts$2;

              return !((_state$removedShifts$2 = state.removedShifts[cellId_]) !== null && _state$removedShifts$2 !== void 0 && _state$removedShifts$2.includes(el.newId));
            });
            wdUpdate = deepClone(workerDay).data.filter(function (el) {
              var _state$updatedShifts$;

              return (_state$updatedShifts$ = state.updatedShifts[cellId_]) === null || _state$updatedShifts$ === void 0 ? void 0 : _state$updatedShifts$.includes(el.newId || el.id);
            });

            if (!((_wdUpdate = wdUpdate) !== null && _wdUpdate !== void 0 && _wdUpdate.length)) {
              wdUpdate = deepClone(workerDay).data.filter(function (el) {
                var _state$updatedShifts$2;

                return (_state$updatedShifts$2 = state.updatedShifts[cellId_]) === null || _state$updatedShifts$2 === void 0 ? void 0 : _state$updatedShifts$2.includes(el.id);
              });
            }

            if (!(wdDelete !== null && wdDelete !== void 0 && wdDelete.length)) {
              _context.next = 31;
              break;
            }

            _iterator = _createForOfIteratorHelper(wdDelete);
            _context.prev = 15;

            _iterator.s();

          case 17:
            if ((_step = _iterator.n()).done) {
              _context.next = 23;
              break;
            }

            wd = _step.value;
            _context.next = 21;
            return API_REQUEST('deleteWorkerDay', {
              'id': wd
            });

          case 21:
            _context.next = 17;
            break;

          case 23:
            _context.next = 28;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](15);

            _iterator.e(_context.t0);

          case 28:
            _context.prev = 28;

            _iterator.f();

            return _context.finish(28);

          case 31:
            if (!((_wdUpdate2 = wdUpdate) !== null && _wdUpdate2 !== void 0 && _wdUpdate2.length)) {
              _context.next = 54;
              break;
            }

            _iterator2 = _createForOfIteratorHelper(wdUpdate);
            _context.prev = 33;

            _iterator2.s();

          case 35:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 46;
              break;
            }

            _wd = _step2.value;

            if (!_wd.is_outsource) {
              _context.next = 42;
              break;
            }

            _context.next = 40;
            return API_REQUEST('updateWorkerDay', _objectSpread(_objectSpread({
              'id': _wd.id
            }, _wd), {}, {
              outsources_ids: _wd.outsources.map(function (item) {
                return item.id;
              })
            }));

          case 40:
            _context.next = 44;
            break;

          case 42:
            _context.next = 44;
            return API_REQUEST('updateWorkerDay', _objectSpread({
              'id': _wd.id
            }, _wd));

          case 44:
            _context.next = 35;
            break;

          case 46:
            _context.next = 51;
            break;

          case 48:
            _context.prev = 48;
            _context.t1 = _context["catch"](33);

            _iterator2.e(_context.t1);

          case 51:
            _context.prev = 51;

            _iterator2.f();

            return _context.finish(51);

          case 54:
            if (!(wdPost !== null && wdPost !== void 0 && wdPost.length)) {
              _context.next = 82;
              break;
            }

            _iterator3 = _createForOfIteratorHelper(wdPost);
            _context.prev = 56;

            _iterator3.s();

          case 58:
            if ((_step3 = _iterator3.n()).done) {
              _context.next = 74;
              break;
            }

            _wd2 = _step3.value;
            _context.next = 62;
            return API_REQUEST('createWorkerDay', _wd2);

          case 62:
            _yield$API_REQUEST = _context.sent;
            _yield$API_REQUEST2 = _slicedToArray(_yield$API_REQUEST, 2);
            error = _yield$API_REQUEST2[0];
            result = _yield$API_REQUEST2[1];

            if (!error) {
              _context.next = 70;
              break;
            }

            return _context.abrupt("return", false);

          case 70:
            _context.next = 72;
            return updateStats({
              result: result,
              currentDepId: currentDepId,
              cellId: cellId,
              commit: commit,
              dispatch: dispatch
            });

          case 72:
            _context.next = 58;
            break;

          case 74:
            _context.next = 79;
            break;

          case 76:
            _context.prev = 76;
            _context.t2 = _context["catch"](56);

            _iterator3.e(_context.t2);

          case 79:
            _context.prev = 79;

            _iterator3.f();

            return _context.finish(79);

          case 82:
            state['newShifts'][cellId_] = [];
            state['removedShifts'][cellId_] = [];
            state['updatedShifts'][cellId_] = [];
            commit('increaseCoverageDataRefresh');
            commit('clearDayInEditing');
            _context.next = 89;
            return dispatch('load', {
              isForce: true,
              resetFilterWorkers: false
            });

          case 89:
            return _context.abrupt("return", true);

          case 90:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[15, 25, 28, 31], [33, 48, 51, 54], [56, 76, 79, 82]]);
  }));

  return function (_x2, _x3) {
    return _ref6.apply(this, arguments);
  };
})();